<template lang="pug">
  .component-backoffice-log
    b User: &nbsp;
    b(v-if="item.user_id") {{ item.user_id }} [{{ item.user_type }}] @ {{ item.ip_address }}
    b(v-else) {{ item.ip_address }}
    hr
    b Entity snapshot:
    pre {{ item.snapshot }}

</template>
<script type="text/babel">

  export default {
    name: "Log",
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Log.vue?4c55b7cc